












import { Component, Vue } from 'vue-property-decorator';
import RoomMenu from '@/browser/components/RoomMenu.vue';
import { BindAsObject } from '@/browser/decorators/dao';
import RoomDAO from '@/browser/dao/RoomDAO';
import Room from '@/models/Room';

@Component({
  components: {
    RoomMenu: RoomMenu as any,
  },
})
export default class RoomAppBar extends Vue {
  @BindAsObject(new RoomDAO()) room!: Room | null;

  get title(): string {
    return this.room ? this.room.title : 'ねこ卓';
  }

  get isLocked(): boolean {
    return (this.room && this.room.isLocked) || false;
  }
}
